import { Model } from '@vuex-orm/core'

export default class Events extends Model {
  static entity = 'events'

  static fields () {
    return {
      // Models
      id: this.attr(null),
      bitrate: this.attr(null),
      created_at: this.attr(null),
      fir_frequency: this.attr(null),
      intercom: this.attr(null),
      livecast_ids: this.attr(null),
      mix_minus: this.attr(null),
      monitor_bitrate: this.attr(null),
      publisher_id: this.attr(null),
      replaycast_ids: this.attr(null),
      roles: this.attr(null),
      status: this.attr(null),
      subscription_ids: this.attr(null),
      title: this.string('New event'),
      transport_wide_cc: this.attr(null),
      updated_at: this.attr(null),
      usage_limit: this.attr(null),
      video_codec: this.attr(null),
      videocast_ids: this.attr(null),
      viewers_count: this.attr(null),
      event_date: this.attr(null),
      event_description: this.attr(null)

    }
  }
}
